import { Component, OnInit, Input } from '@angular/core';
import { ProductoService } from '../../../services/producto.service';
import * as Chart from 'chart.js';
import * as numeral from 'numeral';

@Component({
    selector: 'chart-productos-mas-vendidos',
    templateUrl: './productos-mas-vendidos.component.html',
    styleUrls: ['./productos-mas-vendidos.component.css'],
    providers: [ProductoService]
})

export class ProductosMasVendidosComponent implements OnInit {
    @Input() periodo: String;
    @Input() fecha_inicio;
    @Input() fecha_fin;
    @Input() order;
    @Input() limit;
    public loading: boolean;
    public data: Array<any>;
    private myChart: any;
    public title: string;

    constructor(
        private productoService: ProductoService,
    ) {
        this.loading = false;
        this.data = [];
        
    }

    ngOnInit() {
        this.title = this.order=='DESC'?'más':'menos';
        this.initChart();
    }

    initChart(periodo?) {
        this.periodo = periodo ? periodo : this.periodo;

        this.loading = true;
        this.getData().then(
            res => {
                let data = [];
                let labels = [];

                this.data.forEach(e => {
                    data.push(e.cantidad);
                    labels.push(e.nombre);
                });

                this.drawChart(data, labels);
                this.loading = false;
            },
            err => {
                this.loading = false;
            }
        );
    }

    getData() {
        return new Promise((resolve, reject) => {
            let qs = "";
            if (this.periodo == "otro") {
                qs = "?periodo=" + this.periodo + "&fecha_inicio=" + this.fecha_inicio + "&fecha_fin=" + this.fecha_fin;
            } else {
                qs = "?periodo=" + this.periodo;
            }
            qs += ("&order="+this.order+"&limit="+this.limit);

            this.productoService.getTopVendidos(qs).subscribe(
                res => {
                    this.data = res.data;
                    resolve(true);
                },
                err => {
                    this.data = [];
                    reject(err);
                }
            );


        });
    }

    updateDataChart(periodo, fecha_inicio, fecha_fin) {
        this.periodo = periodo ? periodo : this.periodo;
        this.fecha_inicio = fecha_inicio ? fecha_inicio : this.fecha_inicio;
        this.fecha_fin = fecha_fin ? fecha_fin : this.fecha_fin;

        this.loading = true;
        this.getData().then(
            res => {
                let data = [];
                let labels = [];

                this.data.forEach(e => {
                    data.push(e.cantidad);
                    labels.push(e.nombre);
                });

                this.myChart.data.datasets[0].data = data;
                this.myChart.data.labels = labels;
                this.myChart.update();

                this.loading = false;
            },
            err => {
                this.loading = false;
            }
        );
    }

    drawChart(data, labels) {
        var ctx = document.getElementById("cvsProductosMasVendidos");

        this.myChart = new Chart(ctx, {
            type: 'pie',
            data: {
                datasets: [{
                    data: data,
                    backgroundColor: [
                        '#7baaf7',
                        '#57bb8a',
                        '#80deea',
                        '#80cbc4',
                        '#e6ee9c',
                    ],
                    borderColor: [
                        '#FFF',
                        '#FFF',
                        '#FFF',
                        '#FFF',
                        '#FFF',
                    ],
                    borderWidth: 1
                }],
                labels: labels
            },
            options: {
                legend: {
                    position: 'top'
                },
                tooltips: {
                    enabled: true,
                    mode: 'single',
                    callbacks: {
                        //title: function (tooltipItem, data) {
                        //    return "Día " + data.labels[tooltipItem[0].index]; 
                        //},
                        //label: function(tooltipItems, data) {
                        //    return "$ " + numeral(data.datasets[0].data[tooltipItems.index]).format('0,0.00');
                        //},
                        footer: function (tooltipItem, data) {
                            let total = 0;
                            data.datasets[0].data.forEach(value => total += parseFloat(value));
                            let porcent = (parseFloat(data.datasets[0].data[tooltipItem[0].index]) / total) * 100;
                            return numeral(porcent).format('0,0.00') + " %";
                        }
                    }
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/charts/productos-mas-vendidos/productos-mas-vendidos.component.ts